module.exports = __webpack_public_path__ + "img/user-3297.cfad5be5.png";